var brekpointSM = 767
var brekpointXS = 576
var customMobileMargin = function () {
  if ($('.vc_row').length) {
    $('.vc_row').each(function () {
      var mobileMarginXS = $(this).data('mobile-margin')
      var mobileMarginSM = $(this).data('mobile-margin-bigger')
      if (mobileMarginXS >= 0 || mobileMarginXS) {
        if (!$(this).hasClass('sized') && $(window).width() <= brekpointXS) {
          mobileMarginXS = mobileMarginXS + ' !important;'
          $(this)
            .css({
              cssText:
                'margin-top:' +
                mobileMarginXS +
                'margin-bottom:' +
                mobileMarginXS,
            })
            .addClass('sized')
        } else if (
          $(this).hasClass('sized') &&
          $(window).width() > brekpointXS
        ) {
          $(this).removeClass('sized')
        }
      }
      if (mobileMarginSM >= 0 || mobileMarginSM) {
        if (
          !$(this).hasClass('sizedSM') &&
          $(window).width() <= brekpointSM &&
          $(window).width() > brekpointXS
        ) {
          mobileMarginSM = mobileMarginSM + ' !important;'
          $(this)
            .css({
              cssText:
                'margin-top:' +
                mobileMarginSM +
                'margin-bottom:' +
                mobileMarginSM,
            })
            .addClass('sizedSM')
        } else if (
          $(this).hasClass('sizedSM') &&
          $(window).width() > brekpointSM
        ) {
          $(this)
            .css({
              'margin-top': '',
              'margin-bottom': '',
            })
            .removeClass('sizedSM')
        }
      }
    })
  }
}

$(document).ready(function () {
  customMobileMargin()
})

$(window).resize(function () {
  customMobileMargin()
})
